<template>
  <div id="app">
    <Header routeValue="2" ref="header"></Header>
    <content class="content" @click="handleDel()">
      <div class="banner_box">
        <div class="banner_content">
          One-stop flexible <br>
          production, efficient cross<br>
          -border e-commerce
        </div>
        <div class="banner_sub_content">
          Regardless if you’re just starting out or if you’re a fast<br>
          growing and established business or an enterprise, we’ve got you covered.<br>
        </div>
        <a @click="toDesign">
          <div class="contact">
            Start Designing
            <a-icon type="right" class="arrow"/>
          </div>
        </a>
      </div>
      <div class="works_box">
        <a-row class="title">
          How one-stop flexible production works
          <div class="sub_title">
            You can manage your entire fulfillment process in just a few steps
          </div>
        </a-row>
        <a-row class="item_01">
          <div class="content">
            <div class="content_list">01</div>
            <div class="content_title">Create Printbelle account</div>
            <div class="content_subtitle">Start by creating a Printbelle account.Then, connect your integrated selling
              store with Printbelle.
            </div>
            <div class="content_button">
              <a @click="toSignUp">
                <div class="contact">
                  Sign up
                  <a-icon type="right" class="arrow"/>
                </div>
              </a>
            </div>
          </div>
        </a-row>
        <a-row class="item_02">
          <div class="content">
            <div class="content_list">02</div>
            <div class="content_title">Design & Sell Products</div>
            <div class="content_subtitle">Choose your favorite product and design it. Then, add them to your store <br>and
              wait for the orders to come in.
            </div>
            <div class="content_button">
              <a @click="toDesign">
                <div class="contact">
                  Start Designing
                  <a-icon type="right" class="arrow"/>
                </div>
              </a>
            </div>
          </div>
        </a-row>
        <a-row class="item_03">
          <div class="content">
            <div class="content_list">03</div>
            <div class="content_title">Fulfilled by Printbelle</div>
            <div class="content_subtitle">Printbelle takes care of the entire fulfillment process. We produce your order
              <br>and ship it to your customer.
            </div>
          </div>
        </a-row>
      </div>
      <div class="who_box">
        <span class="title">Who we are?</span>
        <span class="des">
          The Printbelle platform unites entrepreneurs with premier printing partners globally, fueling a new wave of eCommerce excellence.
          <br>Businesses created by regular individuals that bring happiness to numerous customers globally.
        </span>
        <div class="number_box">
          <div class="content_info">
            <div class="item_list">
              <div class="item">
                <span class="item_number">650+</span>
                <span class="item_des">Custom products</span>
              </div>
              <div class="item">
                <span class="item_number">$2,000,000+</span>
                <span class="item_des">Invested in printing equipment</span>
              </div>
              <div class="item">
                <span class="item_number">3~5days</span>
                <span class="item_des">Fulfillment time</span>
              </div>
              <div class="item">
                <span class="item_number">10,000,000+</span>
                <span class="item_des">Items fulfilled</span>
              </div>
            </div>
          </div>
          <div class="team_box">
            <div class="team_item">
              <div class="img_view">
                <img class="team_img" src="../assets/team_1.png">
              </div>
              <span class="team_name">Professional<br/>technical team</span>
              <span class="team_des">
                Strictly select high-quality products from various industries<br/>
                and efficiently complete production, quality inspection, deliv-<br/>
                ery, and after-sales one-stop services
              </span>
            </div>
            <div class="team_item" style="margin-left: 43px">
              <div class="img_view">
                <img class="team_img" src="../assets/team_2.png">
              </div>
              <span class="team_name">Adavanced printing<br/>machines</span>
              <span class="team_des">
                We have more than 30 UV printing equipment and more than 20<br/>
                large-scale laser cutting equipment to respond to orders effi-<br/>
                ciently
              </span>
            </div>
            <div class="team_item" style="margin-left: 43px">
              <div class="img_view">
                <img class="team_img" src="../assets/team_3.png">
              </div>
              <span class="team_name">High-required quality<br/>control</span>
              <span class="team_des">
                Strict quality control in multiple links provides you with the<br/>
                 best fulfillment experience.
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="our_vision_box">
        <span class="title">Our vision</span>
        <div class="vision_box">
          <div class="aboutus-vision-details">
            <div class="aboutus-vision-details-01">
              <div class="aboutus-vision-details-01-bg"></div>
              <div class="aboutus-vision-details-title">
                Create benefits for<br>customers
              </div>
              <div class="aboutus-vision-details-item">
                <div class="white-point"/>
                Zero warehousing<br>
                <div class="white-point"/>
                Low cost<br>
                <div class="white-point"/>
                High profit
              </div>
            </div>
            <div class="aboutus-vision-details-02">
              <div class="aboutus-vision-details-02-bg"></div>
              <div class="aboutus-vision-details-title">
                Add life to your<br>product
              </div>
              <div class="aboutus-vision-details-item">
                <div class="white-point"/>
                Flexible customization<br>
                <div class="white-point"/>
                Personalized production<br>
                <div class="white-point"/>
                Fashion innovation
              </div>
            </div>
            <div class="aboutus-vision-details-03">
              <div class="aboutus-vision-details-03-bg"></div>
              <div class="aboutus-vision-details-title">
                Create opportunities<br>
                for e-commerce
              </div>
              <div class="aboutus-vision-details-item">
                <div class="white-point"/>
                Massive inventory<br>
                <div class="white-point"/>
                Smart system<br>
                <div class="white-point"/>
                Improve efficiency
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="service_box">
        <span class="title">We are at your service</span>
        <span class="des">For further cooperation, please fill in the information</span>
        <div class="from_box">
          <a-form-model
            style="margin-bottom: 55px"
            ref="form"
            :model="form"
            :rules="rules"
            slot="content"
            :labelCol="{ span: 4 }"
            :wrapperCol="{ span: 20 }">
            <a-form-model-item label="Name" prop="applyName">
              <a-input v-model="form.applyName" placeholder="Please enter your name" style="width: 500px"/>
            </a-form-model-item>
            <a-form-model-item label="E-mail" prop="email">
              <a-input v-model="form.email" placeholder="Please enter your email address" style="width: 500px"/>
            </a-form-model-item>
            <a-form-model-item label="Message" prop="remark">
              <a-textarea v-model="form.remark" placeholder="Please enter message"
                          :auto-size="{ minRows: 3, maxRows: 5 }" style="width: 500px"/>
            </a-form-model-item>
          </a-form-model>
          <div class="business_box">
            <span class="business">Are you ready to start your own business with printbelle?</span>
            <div class="join_us" @click="submitForm">Join us</div>
          </div>

        </div>


      </div>

      <a-modal v-model="visible" :footer="null" @ok="handleOk" :width="560">
        <div>
          <div style="display: flex;align-items: center;justify-content: center;margin-top: 9px;margin-bottom: 21px">
            <img src="@/assets/succeed.png">
          </div>
          <p
            style="display: flex;flex-direction: column; width: 100%;line-height: 28px;font-size: 16px;color: #222222;text-align: center;align-items: center">
            <span>Thank you for reaching out. We will be in touch within 48 hours For</span>
            <span>urgent matters, please email us directly at  <a style="color: #2A79FA" :href="email">support@printbelle.com.</a></span>
            <span>Your patience is appreciated.</span>
          </p>
        </div>
      </a-modal>
    </content>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../components/Header.vue'
import Footer from '../components/Footer.vue'
import countTo from 'vue-count-to'
import {get, post} from '@/api'

export default {
  name: 'About',
  components: {
    Header,
    Footer,
    countTo
  },
  data () {
    return {
      visible: false,
      email: 'mailto:support@printbelle.com',
      title: '',
      skypeConfig: '',
      dataList: [],
      options: [],
      isLoading: false,
      form: {
        applyName: undefined,
        email: undefined,
        remark: undefined,
      },
      rules: {
        applyName: [{required: true, message: 'Please enter your name', trigger: 'blur'}],
        email: [
          {
            required: true,
            type: 'email',
            message: 'Please enter the correct email address',
            trigger: ['blur', 'change']
          }
        ],
        remark: [{required: true, message: 'Please enter message', trigger: 'blur'}],
      },
      pageNum: 1,
      pageSize: 20
    }
  },
  mounted () {
    const hash = window.location.hash
    if (hash === '#step1') {
      window.scrollTo({
        top: 4050,
        behavior: 'smooth'
      })
    } else {
      window.scrollTo(0, 0)
    }
    this.title = window.location.href + 'About'
  },
  created () {
    this.getSkypeConfig()
  },
  methods: {
    handleDel () {
      this.$refs.header.delProductValue()
    },
    getSkypeConfig () {
      get('/merchant/index/config/skype')
        .then(response => {
          this.skypeConfig = 'skype:' + response.data + '?chat'
        })
        .catch(error => {
          console.error(error)
        })

    },
    toDesign () {
      window.open(process.env.VUE_APP_FULFILLMENT + 'product/designer', '_blank')
    },
    toSignUp () {
      window.open(process.env.VUE_APP_FULFILLMENT + 'user/register', '_blank')
    },
    submitForm () {
      this.$refs.form.validate(valid => {
        if (valid) {
          post('/index/apply', this.form)
            .then(response => {
              this.visible = true
            })
            .catch(error => {
              console.error(error)
            })
        } else {
          return false
        }
      })
    },
    toDetailsDes (item) {
      this.$router.push({path: `/designs/${item.id}`})
    },
    handleOk (e) {
      this.visible = false
    },
  },
}
</script>
<style scoped lang="less">

.content {
  display: flex;
  flex-direction: column;
  background: #F8F8F8;

  .banner_box {
    height: 591px;
    background-image: url(../assets/about_bg.jpg);
    position: relative;
    box-shadow: inset -20px 40px 20px -32px rgba(0, 0, 0, 0.07);
    margin-top: 96px;

    .banner_content {
      position: absolute;
      top: 83px;
      left: 211px;
      width: 1024px;
      height: 177px;

      font-family: Cerebri Sans;
      font-weight: bold;
      font-size: 58px;
      color: #222222;
      line-height: 66px;
    }

    .banner_sub_content {
      position: absolute;
      top: 304px;
      left: 211px;

      height: 69px;
      font-family: Roboto;
      font-weight: 400;
      font-size: 16px;
      color: #222222;
      line-height: 26px;
    }

    .contact {
      padding-left: 23px;
      font-family: Roboto;
      font-weight: 400;
      font-size: 16px;
      color: #FFFFFF;
      position: absolute;
      top: 430px;
      left: 211px;
      width: 184px;
      height: 47px;
      line-height: 47px;
      cursor: pointer;
      background: #343183;
      border-radius: 5px;

      .arrow {
        font-size: 16px;
        width: 14px;
        height: 20px;
        margin-left: 14px;
        animation: slide-right 2s infinite;
      }
    }
  }

  .works_box {
    background: #ffffff;
    padding-top: 81px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .title {
      font-family: Cerebri Sans;
      font-weight: bold;
      font-size: 55px;
      color: #222222;
      text-align: center;

      .sub_title {
        margin-top: 8px;
        font-family: Roboto;
        font-weight: 500;
        font-size: 24px;
        color: #485256;
      }
    }

    .item_01 {
      margin-top: 52px;
      width: 1261px;
      height: 402px;
      background-image: url(../assets/about_work01.png);

      .content {
        position: absolute;
        background: #ffffff;
        left: 711px;
        margin-top: 45px;
        width: auto;

        .content_list {
          width: 81px;
          height: 81px;
          font-family: OPPOSans;
          font-weight: bold;
          font-size: 72px;
          color: #000000;
          font-style: italic;
          opacity: 0.2;
        }

        .content_title {
          margin-top: 15px;
          font-family: Roboto;
          font-weight: bold;
          font-size: 32px;
          color: #222222;
        }

        .content_subtitle {
          margin-top: 10px;
          font-family: Roboto;
          font-weight: 400;
          font-size: 16px;
          color: #485256;
          line-height: 26px;
        }

        .content_button {
          margin-top: 30px;
          width: 146px;
          height: 47px;
          background: #343183;
          border-radius: 3px;

          .contact {
            font-family: Roboto;
            font-weight: 400;
            font-size: 16px;
            line-height: 47px;
            padding-left: 33px;
            color: #FFFFFF;

            .arrow {
              font-size: 16px;
              width: 14px;
              height: 20px;
              margin-left: 14px;
              animation: slide-right 2s infinite;
            }
          }
        }
      }
    }

    .item_02 {
      margin-top: 41px;
      height: 402px;
      width: 1262px;
      height: 402px;
      background-image: url(../assets/about_work02.png);

      .content {
        margin-top: 45px;
        position: absolute;
        background: #ffffff;
        left: 11px;
        width: auto;

        .content_list {
          width: 81px;
          height: 81px;
          font-family: OPPOSans;
          font-weight: bold;
          font-size: 72px;
          color: #000000;
          font-style: italic;
          opacity: 0.2;
        }

        .content_title {
          margin-top: 15px;
          font-family: Roboto;
          font-weight: bold;
          font-size: 32px;
          color: #222222;
        }

        .content_subtitle {
          margin-top: 10px;
          font-family: Roboto;
          font-weight: 400;
          font-size: 16px;
          color: #485256;
          line-height: 26px;
        }

        .content_button {
          margin-top: 30px;
          width: 190px;
          height: 47px;
          background: #343183;
          border-radius: 3px;

          .contact {
            font-family: Roboto;
            font-weight: 400;
            font-size: 16px;
            line-height: 47px;
            padding-left: 26px;
            color: #FFFFFF;

            .arrow {
              font-size: 16px;
              width: 14px;
              height: 20px;
              margin-left: 14px;
              animation: slide-right 2s infinite;
            }
          }
        }
      }
    }

    .item_03 {
      margin: 41px 0 118px 0;
      height: 403px;
      width: 1261px;
      height: 403px;
      background-image: url(../assets/about_work03.png);

      .content {
        position: absolute;
        background: #ffffff;
        left: 711px;
        margin-top: 80px;
        width: auto;

        .content_list {
          width: 81px;
          height: 81px;
          font-family: OPPOSans;
          font-weight: bold;
          font-size: 72px;
          color: #000000;
          font-style: italic;
          opacity: 0.2;
        }

        .content_title {
          margin-top: 15px;
          font-family: Roboto;
          font-weight: bold;
          font-size: 32px;
          color: #222222;
        }

        .content_subtitle {
          margin-top: 10px;
          font-family: Roboto;
          font-weight: 400;
          font-size: 16px;
          color: #485256;
          line-height: 26px;
        }
      }
    }
  }

  .who_box {
    background: #F8FAFC;
    display: flex;
    flex-direction: column;
    align-items: center;

    .title {
      z-index: 1;
      font-family: Cerebri Sans;
      font-weight: bold;
      font-size: 55px;
      color: #212121;
      line-height: 48px;
      margin-top: 74px;
    }

    .des {
      z-index: 1;
      font-family: Roboto;
      font-weight: 400;
      font-size: 18px;
      color: #485256;
      text-align: center;
      line-height: 30px;
      margin-top: 30px;
    }

    .number_box {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 61px 0 67px 0;
      width: 100%;

      .content_info {
        z-index: 0;
        background-image: url(../assets/about_who.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;
        width: 100%;
        height: 609px;
        margin-top: -221px;
        display: flex;
        align-items: center;
        justify-items: center;
        flex-direction: column;

        .item_list {
          position: relative;
          top: 246px;
          width: 1528px;
          display: flex;
          align-items: center;
          justify-items: center;
          flex-direction: row;

          .item {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 25%;

            .item_number {
              font-family: Roboto;
              font-weight: bold;
              font-size: 50px;
              color: #FFFFFF;
            }

            .item_des {
              font-family: Roboto;
              font-weight: bold;
              font-size: 18px;
              color: #FFFFFF;
            }
          }
        }
      }

      .team_box {
        width: 1500px;
        display: flex;
        margin-top: -123px;


        .team_item {
          display: flex;
          flex-direction: column;
          align-items: center;

          .img_view {
            width: 471px;
            height: 345px;
            cursor: pointer;

            .team_img {
              width: 100%;
              height: 100%;
              transition: all ease 0.6s;
            }

            .team_img:hover {
              margin-top: -15px;
            }
          }


          .team_name {
            font-family: Cerebri Sans;
            font-weight: bold;
            font-size: 36px;
            color: #212121;
            text-align: center;
            margin-top: 45px;
            line-height: 42px;
          }

          .team_des {
            font-family: Roboto;
            font-weight: 400;
            font-size: 16px;
            color: #485256;
            margin-top: 23px;
            text-align: center;
            margin-bottom: 20px;
            line-height: 28px;
          }
        }

      }
    }
  }

  .our_vision_box {
    background: #343183;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 586px;

    .title {
      font-family: Cerebri Sans;
      font-weight: bold;
      font-size: 55px;
      color: #FFFFFF;
      margin-top: 54px;
    }

    .vision_box {
      font-family: Roboto;
      width: 1500px;
      height: 607px;
      display: flex;
      flex-direction: row;
      margin-top: 22px;
      margin-bottom: 88px;
      align-content: center;
      justify-content: center;

      .aboutus-vision-details {
        width: 1500px;
        display: flex;
        flex-direction: row;
        align-content: center;
        justify-content: center;
      }

      .aboutus-vision-details-01 {
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        width: 33%;

        .aboutus-vision-details-01-bg {
          width: 168px;
          height: 168px;
          background-image: url(../assets/vision-01.png);
          background-size: 100% 100%;
        }
      }

      .aboutus-vision-details-02 {
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        width: 30%;

        .aboutus-vision-details-02-bg {
          width: 168px;
          height: 168px;
          background-image: url(../assets/vision-02.png);
          background-size: 100% 100%;
        }
      }

      .aboutus-vision-details-03 {
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        width: 37%;

        .aboutus-vision-details-03-bg {
          width: 168px;
          height: 168px;
          background-image: url(../assets/vision-03.png);
          background-size: 100% 100%;
        }
      }

      .white-point {
        display: inline-block;
        background-color: rgba(255, 255, 255, 1);
        border-radius: 50%;
        width: 10px;
        height: 10px;
        margin-right: 22px;
      }

      .aboutus-vision-details-title {
        margin-top: 19px;

        font-family: Roboto;
        font-weight: bold;
        font-size: 30px;
        color: #FFFFFF;
        line-height: 32px;
      }

      .aboutus-vision-details-item {
        margin-top: 18px;
        text-align: left;

        font-family: Roboto;
        font-weight: 400;
        font-size: 16px;
        color: #FFFFFF;
        line-height: 35px;
      }
    }
  }

  .service_box {
    background: #FFFFFF;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 53px;

    .title {
      font-family: Cerebri Sans;
      font-weight: bold;
      font-size: 55px;
      margin-top: 72px;
      color: #212121;
    }

    .des {
      font-family: Roboto;
      font-weight: 500;
      font-size: 24px;
      color: #485256;
      margin-top: 8px;
      opacity: 0.8;
    }

    .from_box {
      font-family: Roboto;
      width: 1499px;
      height: 450px;
      margin-top: 37px;
      padding-left: 330px;
      padding-top: 30px;
      border-radius: 20px;
      position: relative;

      /deep/ .ant-form label {
        font-size: 18px;
        font-weight: 500;
      }

      /deep/ .ant-input {
        height: 42px;
      }

      .business_box {
        display: flex;
        flex-direction: column;
        position: absolute;
        bottom: 35px;

        .business {
          font-family: Roboto;
          font-weight: 500;
          font-size: 18px;
          color: #222222;
          margin-left: 200px;
        }

        .join_us {
          width: 247px;
          height: 53px;
          text-align: center;
          background: #343183;
          border-radius: 27px;
          font-size: 30px;
          margin-top: 30px;
          margin-left: 295px;
          line-height: 53px;
          cursor: pointer;
          font-family: Cerebri Sans;
          font-weight: 600;
          color: #FFFFFF;
        }
      }


    }

  }


  @keyframes slide-right {
    0% {
      transform: translateX(0);
    }
    50% {
      transform: translateX(50%);
    }
    100% {
      transform: translateX(0);
    }
  }

}

/deep/ .ant-modal-close-x {
  width: 40px;
  height: 40px;
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/views/About.vue